













































































































































































































import { Component, Vue } from "vue-property-decorator";
import CtaButton from "../ctaButton/ctaButton.vue";
import HomeCarouselFrame from "./HomeCarouselFrame.vue";
import { Settings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import store from "@/shared/core/store";
import { Format } from "@/shared/core/helpers/formatHelper";
import { ShopService } from "@/shared/core/services/shopService";
import IconCartOutline from "@/shared/components/icons/IconCartOutline.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

@Component({
  components: {
    CtaButton,
    HomeCarouselFrame,
    IconCartOutline,
    VueSlickCarousel,
  },
})
export default class HomeFeaturedProducts extends Vue {
  products: any[] = [];
  activeIndex = 0;
  touchStartX: number | null = null;

  get activeProduct() {
    if (this.products.length === 0) return {};
    return this.products[this.activeIndex] || this.products[0];
  }

  get featuredTitleLines() {
    const title = String(this.$t("Featured products")).trim();
    if (!title) return [""];
    const spaceIndex = title.indexOf(" ");
    if (spaceIndex === -1) return [title];
    return [title.slice(0, spaceIndex), title.slice(spaceIndex + 1)];
  }

  get isDouble() {
    return this.products.length === 2;
  }

  get shouldAutoplay() {
    return this.products.length > 1;
  }

  get activeProductLink() {
    return this.productLink(this.activeProduct);
  }

  get visibleOffsets() {
    const total = this.products.length;
    if (total <= 1) return [0];
    if (total === 2) return [0, 1];
    const offsets = [-1, 0, 1];
    if (total > 3) offsets.push(2);
    if (total > 4) offsets.unshift(-2);
    return offsets;
  }

  get thumbProducts() {
    if (this.products.length > 4) return this.visibleProducts;
    return this.visibleProducts.filter((item) => Math.abs(item.offset) < 2);
  }

  get visibleProducts() {
    const total = this.products.length;
    if (total === 0) return [];
    return this.visibleOffsets.map((offset) => {
      const index = (this.activeIndex + offset + total) % total;
      const product = this.products[index] || this.products[0];
      const ariaLabel = product.name
        ? product.name
        : String(this.$t("Featured products"));
      const link = this.productLink(product);
      return {
        offset,
        index,
        product,
        key: String(index),
        ariaLabel,
        link,
      };
    });
  }

  async mounted() {
    const url = `${Settings.HostName}/api/products/trending-products`;
    const data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash getting featured products");
      return;
    }
    this.products = data.model || data.data || [];
    this.activeIndex = 0;
    this.$emit("loaded", this.products.length);
  }

  setActiveOffset(offset: number) {
    if (this.products.length === 0) return;
    const total = this.products.length;
    const nextIndex = (this.activeIndex + offset + total) % total;
    this.setActiveIndex(nextIndex);
  }

  get carouselSettings() {
    const shouldLoop = this.products.length > 1;
    const shouldAutoplay = this.shouldAutoplay;
    return {
      arrows: false,
      dots: false,
      infinite: shouldLoop,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: shouldAutoplay,
      speed: 0,
      autoplaySpeed: 5000,
      cssEase: "ease-in-out",
      pauseOnHover: false,
      pauseOnFocus: false,
    };
  }

  onAfterChange(current: any) {
    if (typeof current === "number") {
      this.activeIndex = current;
      return;
    }
    if (current && typeof current.currentSlide === "number") {
      this.activeIndex = current.currentSlide;
    }
  }

  setActiveIndex(index: number) {
    if (this.products.length === 0) return;
    const total = this.products.length;
    const nextIndex = ((index % total) + total) % total;
    this.activeIndex = nextIndex;
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.goTo) {
      carousel.goTo(nextIndex);
    }
    this.restartAutoplay();
  }

  circleClass(offset: number) {
    if (offset === 0) return "homeFeaturedProducts__circle--center";
    if (offset === -1) return "homeFeaturedProducts__circle--left";
    if (offset === 1) return "homeFeaturedProducts__circle--right";
    if (offset === -2) return "homeFeaturedProducts__circle--outer-left";
    if (offset === 2) return "homeFeaturedProducts__circle--outer-right";
    return "homeFeaturedProducts__circle--center";
  }

  thumbClass(offset: number) {
    if (offset === 0) return "homeFeaturedProducts__thumb--center";
    if (offset === -1) return "homeFeaturedProducts__thumb--left";
    if (offset === 1) return "homeFeaturedProducts__thumb--right";
    if (offset === -2) return "homeFeaturedProducts__thumb--outer-left";
    if (offset === 2) return "homeFeaturedProducts__thumb--outer-right";
    return "homeFeaturedProducts__thumb--center";
  }

  onHeroImageLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    img.classList.toggle(
      "homeFeaturedProducts__img--cover",
      img.naturalWidth > img.naturalHeight
    );
  }

  onCircleClick(offset: number) {
    if (offset === 0) return;
    this.setActiveOffset(offset);
  }

  onArrowClick(direction: number) {
    if (direction > 0) {
      this.nextProduct();
    } else {
      this.prevProduct();
    }
  }

  nextProduct() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.next) {
      carousel.next();
    }
    this.restartAutoplay();
  }

  prevProduct() {
    const carousel = this.$refs.carousel as any;
    if (carousel && carousel.prev) {
      carousel.prev();
    }
    this.restartAutoplay();
  }

  onTouchStart(e: TouchEvent) {
    this.touchStartX = e.touches[0].clientX;
  }

  onTouchEnd(e: TouchEvent) {
    if (this.touchStartX === null) return;
    const deltaX = e.changedTouches[0].clientX - this.touchStartX;
    this.touchStartX = null;
    if (Math.abs(deltaX) < 40) return;
    if (deltaX < 0) this.nextProduct();
    else this.prevProduct();
  }

  restartAutoplay() {
    if (!this.shouldAutoplay) return;
    const carousel = this.$refs.carousel as any;
    if (!carousel) return;
    if (carousel.pause) {
      carousel.pause();
    } else if (carousel.slickPause) {
      carousel.slickPause();
    }
    if (carousel.play) {
      carousel.play();
      return;
    }
    if (carousel.slickPlay) {
      carousel.slickPlay();
    }
  }

  productLink(product: any) {
    if (!product) return "";
    if (product.id === undefined || product.id === null || product.id === "") {
      return "";
    }
    return `/shop/${product.id}`;
  }

  getHeroImage(product: any) {
    return this.resolveProductImage(product, [
      "heroImage",
      "image",
      "mainImage",
      "logo",
    ]);
  }

  getThumbImage(product: any) {
    return this.resolveProductImage(product, [
      "thumbnail",
      "thumb",
      "logo",
      "image",
      "mainImage",
    ]);
  }

  resolveProductImage(product: any, fields: string[]) {
    if (!product) return this.getImage();
    for (const field of fields) {
      const value = product[field];
      if (typeof value === "string" && value.trim()) {
        return this.getImage(value);
      }
    }
    return this.getImage();
  }

  getImage(name?: string | null) {
    const fallback =
      store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    if (!name) return fallback;
    if (/^https?:\/\//i.test(name)) return name;
    return store.state.settings.Uploads + "/" + name;
  }

  addActiveToCart(e: any) {
    if (!this.activeProduct || !this.activeProduct.id) {
      return;
    }
    e.preventDefault();
    new ShopService().addProductToCart(this.activeProduct, 1, e.currentTarget);
  }

  formatCurrency(number: number) {
    if (number === undefined || number === null) return "";
    return Format.formatCurrency(number.toString());
  }
}
